import { Tabs } from 'finara-components';
import type { TabItem } from 'finara-components';
import { useState } from 'react';

import { Navbar } from '@/components/super-admin/general/Navbar';
import { superAdminNavItems } from '@/data/super-admin/general/navigationData';
import { PayrollAdvanceTab } from '@/types/credits';

import { AdvanceDashboard } from './components/AdvanceDashboard';
import { AdvanceRequests } from './components/AdvanceRequests';

export const AdelantosDeNomina: React.FC = () => {
  const [activeTab, setActiveTab] = useState<PayrollAdvanceTab>('solicitudes');

  const tabs: TabItem[] = [
    { id: 'solicitudes', title: 'Solicitudes', onSelect: () => setActiveTab('solicitudes') },
    { id: 'dashboard', title: 'Dashboard', onSelect: () => setActiveTab('dashboard') },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AdvanceDashboard />;
      case 'solicitudes':
        return <AdvanceRequests />;
      default:
        return <AdvanceDashboard />;
    }
  };

  return (
    <div className="min-h-screen">
      {/* Navbar */}
      <Navbar navItems={superAdminNavItems} userName="Admin User" activeItem="Operaciones" />

      {/* Main Content */}
      <div className="px-4 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-brand-white">Adelantos de Nómina</h1>
              <p className="text-muted mt-1">
                Sistema de financiamiento y adelantos para empleados
              </p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-6">
          <Tabs tabs={tabs} activeTabId={activeTab} />
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </div>
  );
};
